<div class="login-container" *ngIf="!_authService.isLoggedIn">
  <div class="login-wrapper">
    <div class="login-left">
      <app-login-left-panel
        [loginModel]="loginModel"
        (submit)="logar()"
      ></app-login-left-panel>
    </div>

    <div class="login-right">
      <app-login-right-panel></app-login-right-panel>
    </div>
  </div>

  <p-messages
    [value]="_messageService.messages"
    [closable]="false"
    class="messages-container"
  ></p-messages>
</div>
